import React from "react";
import ReactDOM from "react-dom";

import axios from "axios";


export default class SelectionCode extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            config: JSON.parse(this.props.config),
            sub:JSON.parse(this.props.sub),
            regions:JSON.parse(this.props.locas),
            departements:[],
            departement:null,
            region:"default",
            cps:[],
            cp:[],
            currentCp:null,
            messageFlash:"",
            openFlash:false,
            prixTotalTTC:null,
        }
        this.handleLoadDepartement = this.handleLoadDepartement.bind(this);
        this.handleSelectCp = this.handleSelectCp.bind(this);
        this.handleAddCp = this.handleAddCp.bind(this);
        this.handleFlashCloseProjet = this.handleFlashCloseProjet.bind(this);
        this.handleDeleteDepart = this.handleDeleteDepart.bind(this);
        this.handleOpenPayment = this.handleOpenPayment.bind(this);
    }
    componentDidMount(){
        
    }
    handleLoadDepartement(value){
        axios.post('/location/departement', {
            region: value,
        }).then(res => {
            this.setState({departements: res.data, region: value});
        }).catch(error => {

        })
    }
    handleSelectCp(value) {
        axios.post('/location/cp', {
            departement: value,
        }).then(res => {
            this.setState({cps: res.data, departement: value});
        }).catch(error => {

        })
    }
    handleAddCp(e){
        e.preventDefault();
        let {cp,currentCp,sub,config,prixTotalTTC} = this.state;
        prixTotalTTC = parseInt(config.comp) * 1.2
        prixTotalTTC = this.financial(prixTotalTTC);
        if(sub[0]){
            if(cp.length < 1){
                cp.push(currentCp);
            }else{
                this.setState({
                    messageFlash:"Vous avez déjà un abonnement 3 code postaux.",
                    openFlash:true,
                })
            }
        }else{
            if(cp.length < 3){
                cp.push(currentCp);
            }else{
                this.setState({
                    messageFlash:"Vous avez déjà pris 3 code postaux.",
                    openFlash:true,
                })
            }
        }
        this.setState({cp,currentCp:null,departement:null,region:"default",prixTotalTTC});
    }
    handleFlashCloseProjet(e){
        e.preventDefault();
        this.setState({
            messageFlash:"",
            openFlash:false,
        })
    }
    handleDeleteDepart(e,index){
        e.preventDefault();
        let {cp} = this.state;
        cp.splice(index,1);
        this.setState({cp});
    }
    handleOpenPayment(e){
        e.preventDefault();
        if(this.state.sub[0]){
            document.getElementById('paimentBlock').style.display = "block";
        }else{
            if(this.state.cp.length < 3){
                this.setState({
                    messageFlash:"Vous n'avez pas sélectioné 3 code postaux.",
                    openFlash:true,
                })
            }else{
                document.getElementById('paimentBlock').style.display = "block";
            }
        }
    }
    financial(x) {
        return Number.parseFloat(x).toFixed(2);
    }
    render(){
        return(
            <>
                <div className="from-control">
                   <h2>Selectioner un code postal</h2>
                   <select className="departementSelect" value={this.state.region} onChange={(e) => this.handleLoadDepartement(e.target.value)}>
                       <option  value="default">Region</option>
                       {
                           this.state.regions.map((value,index) => (
                               value.region !== "Toutes les régions" ?
                               <option key={index}>{value.region}</option>
                               :null
                           ))
                       }
                   </select>
                   {
                       this.state.region !== "default" &&
                       <select className="departementSelect" onChange={(e) => this.handleSelectCp(e.target.value)}>
                           <option >Département</option>
                           {
                               this.state.departements.map((value,index) =>  (
                                   value.departement !== "" ?
                                   <option key={index}>{value.departement}</option>
                                   :null
                               ))
                           }
                       </select>
                   }
                   {
                       this.state.departement !== null &&
                       <>
                       <select className="departementSelect" onChange={(e) => this.setState({currentCp:e.target.value})}>
                           <option>Code postal</option>
                           {
                               this.state.cps.map((value,index) => (
                                   value.cp !== null ?
                                    <option key={index}>{value.cp}</option>
                                   :null
                               ))
                           }
                       </select>
                       <a href="" onClick={(e) => this.handleAddCp(e)} >
                        <svg xmlns="http://www.w3.org/2000/svg" width="15.013" height="15.013" viewBox="0 0 15.013 15.013">
                            <g id="Icon_ionic-md-add-circle-outline" data-name="Icon ionic-md-add-circle-outline" transform="translate(-3.375 -3.375)">
                                <path id="Tracé_8" data-name="Tracé 8" d="M18.2,15.1H15.1v3.1H13.58V15.1h-3.1V13.58h3.1v-3.1H15.1v3.1h3.1Z" transform="translate(-3.457 -3.457)" fill="#2f2f2f"/>
                                <path id="Tracé_9" data-name="Tracé 9" d="M10.881,4.891A5.988,5.988,0,1,1,6.645,6.645a5.966,5.966,0,0,1,4.237-1.754m0-1.516a7.506,7.506,0,1,0,7.506,7.506,7.505,7.505,0,0,0-7.506-7.506Z" fill="#2f2f2f"/>
                            </g>
                        </svg>
                       <span>Ajouter</span>
                    </a>
                       </>
                   }
                   {
                    this.state.cp[0] &&
                    <div className="listeDepartementSelect">
                    <h2>Liste des départements sélectionnés</h2>
                    <div className="listeDepartementHeader">
                        <div className="blockDepart">
                            <p>Département</p>
                        </div>
                        <div className="blockPrix">
                            <p>Prix en € HT</p>
                        </div>
                    </div>
                    <div className="listeDepartementBody">
                        {
                            this.state.cp.map((value,index) => (
                                <div key={index}>
                                    <div className="blockDepart">
                                        <p>{value}</p>
                                    </div>
                                    <div className="blockPrix">
                                        {
                                            this.state.sub[0] ?
                                            <p>{this.financial(54)}</p>
                                            :
                                            <p>{this.financial(108)}</p>
                                        }
                                        <a href="" onClick={(e) => this.handleDeleteDepart(e,index)} >
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="#939393" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10 2.25C9.58579 2.25 9.25 2.58579 9.25 3V3.75H5C4.58579 3.75 4.25 4.08579 4.25 4.5C4.25 4.91421 4.58579 5.25 5 5.25H19C19.4142 5.25 19.75 4.91421 19.75 4.5C19.75 4.08579 19.4142 3.75 19 3.75H14.75V3C14.75 2.58579 14.4142 2.25 14 2.25H10Z" />
                                            <path d="M10 10.65C10.4142 10.65 10.75 10.9858 10.75 11.4L10.75 18.4C10.75 18.8142 10.4142 19.15 10 19.15C9.58579 19.15 9.25 18.8142 9.25 18.4L9.25 11.4C9.25 10.9858 9.58579 10.65 10 10.65Z" />
                                            <path d="M14.75 11.4C14.75 10.9858 14.4142 10.65 14 10.65C13.5858 10.65 13.25 10.9858 13.25 11.4V18.4C13.25 18.8142 13.5858 19.15 14 19.15C14.4142 19.15 14.75 18.8142 14.75 18.4V11.4Z" />
                                            <path  d="M5.99142 7.91718C6.03363 7.53735 6.35468 7.25 6.73684 7.25H17.2632C17.6453 7.25 17.9664 7.53735 18.0086 7.91718L18.2087 9.71852C18.5715 12.9838 18.5715 16.2793 18.2087 19.5446L18.189 19.722C18.045 21.0181 17.0404 22.0517 15.7489 22.2325C13.2618 22.5807 10.7382 22.5807 8.25108 22.2325C6.95954 22.0517 5.955 21.0181 5.81098 19.722L5.79128 19.5446C5.42846 16.2793 5.42846 12.9838 5.79128 9.71852L5.99142 7.91718ZM7.40812 8.75L7.2821 9.88417C6.93152 13.0394 6.93152 16.2238 7.2821 19.379L7.3018 19.5563C7.37011 20.171 7.84652 20.6612 8.45905 20.747C10.8082 21.0758 13.1918 21.0758 15.5409 20.747C16.1535 20.6612 16.6299 20.171 16.6982 19.5563L16.7179 19.379C17.0685 16.2238 17.0685 13.0394 16.7179 9.88417L16.5919 8.75H7.40812Z" />
                                        </svg>
                                        </a>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                    <div className="listeDepartementFooter">
                    <div className="blockDepart">
                            <p>Total TTC</p>
                        </div>
                        <div className="blockPrix">
                            <p>{this.state.prixTotalTTC}</p>
                            <div className="hiddenBlockReplace"></div>
                        </div>
                    </div>
                    <div className="openPayment">
                        <a href="" onClick={(e) => this.handleOpenPayment(e)}>Passer au mode de paiement</a>
                    </div>
                    <input type="hidden" value={JSON.stringify(this.state.cp)} name="card" />
               </div>
                   }
                </div>
                {/* MODAL Flash MESSAGE */}
               {
                    this.state.openFlash &&
                        <div className="modal modalDelete">
                            <div className="backgroundModal">
                                <div className="contentModal">
                                    <div className="message">
                                        <p>{this.state.messageFlash}</p>
                                    </div>
                                    <div className="action blue">
                                        <a href="" onClick={(e) => this.handleFlashCloseProjet(e)}>OK</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                }
            </>
        )
    }
}
if (document.getElementById('selectionCode')) {
    const element = document.getElementById('selectionCode');
    let props = Object.assign({}, element.dataset);
    ReactDOM.render(<SelectionCode {...props}/>, document.getElementById('selectionCode'));
}